import Button from '@Components/Buttons/Button/index'
import Navigation from '@App/navigation/index'
import React from 'react'

interface ChangeRequestViewActionsProps {
    rightsholderId: number
    submissionId: number
    updateStatus: (status: 'APPROVED' | 'DISMISSED') => void
}
const ChangeRequestViewActions = ({ rightsholderId, submissionId, updateStatus }: ChangeRequestViewActionsProps) => (
    <>
        <p className="review-note">
            This request requires your approval. Review the details below and choose whether to submit or dismiss the
            songwriter&apos;s request to update shares. If needed, you can also select Edit Shares to adjust the shares
            to an amount different from the songwriter&apos;s suggested update.
        </p>
        <div className="review-actions">
            <p className="review-actions-title">Review Actions</p>
            <div className="review-actions-buttons">
                <Button mainColor type="primary" onClick={() => updateStatus('APPROVED')}>
                    Approve
                </Button>
                <Button mainColor type="primary" onClick={() => updateStatus('DISMISSED')}>
                    Reject
                </Button>
                <a
                    className="view-original-link"
                    href={Navigation.rightholder.registrationHistory.submission(rightsholderId, submissionId)}
                    target="_blank"
                    rel="noreferrer"
                >
                    View original work in new tab
                </a>
            </div>
        </div>
    </>
)

export default ChangeRequestViewActions
